import axios from "axios";

const varAxios = axios.create({
//baseURL: 'https://alitisdev.alitis.se/',
baseURL:'https://alitisapp.regionuppsala.se/AlecomFirstResponderAPI/',
  headers: {
    'Content-Type': 'application/json',
    //  'Access-Control-Allow-Origin': 'localhost:3001'
    //'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
  },
  // withCredentials: true
});

export default varAxios;

